<template>
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
        <v-card>
            <v-toolbar flat color="#1d2735" dark>
                <v-toolbar-title>{{
                    ticketId ? 'Editar Ticket' : 'Nuevo Ticket'
                }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <div
                    v-if="ticketId && (ticket.creador || ticket.creador_nombre)"
                    class="d-flex align-center"
                >
                    <v-icon small class="mr-2 white--text"
                        >mdi-account-circle</v-icon
                    >
                    <span class="text-body-2 white--text">
                        Creado por: {{ getCreadorNombre(ticket.creador) }}
                    </span>
                </div>
            </v-toolbar>

            <v-card-text class="pa-4" style="max-height: 70vh">
                <loader :loading="loading"></loader>
                <v-form ref="form" v-model="valid">
                    <v-row>
                        <v-col cols="6" md="2">
                            <v-autocomplete
                                label="Estado"
                                outlined
                                dense
                                v-model="ticket.id_estado_ticket"
                                :items="estados"
                                item-text="descripcion"
                                item-value="id"
                                :readonly="!edit"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="6" md="2">
                            <v-autocomplete
                                label="Departamento"
                                outlined
                                dense
                                v-model="ticket.id_departamento"
                                :items="departamentos"
                                item-text="descripcion"
                                :readonly="!edit"
                                item-value="id"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="6" md="2">
                            <v-autocomplete
                                label="Urgencia"
                                outlined
                                dense
                                v-model="ticket.id_urgencia"
                                :items="urgencia"
                                item-text="descripcion"
                                item-value="id"
                                :readonly="!edit"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="6" md="2">
                            <date-select
                                :outlined="true"
                                label="Fecha de realización"
                                v-model="ticket.fecha_realizacion"
                                dense
                                rounded
                                :disabled="isDateSelectDisabled"
                            ></date-select>
                        </v-col>
                        <v-col cols="6" md="2">
                            <date-select
                                :outlined="true"
                                label="Fecha de finalización"
                                v-model="ticket.fecha_finalizacion"
                                dense
                                rounded
                                :disabled="isDateSelectDisabled"
                            ></date-select>
                        </v-col>
                        <v-col cols="6" md="1">
                            <v-checkbox
                                dense
                                v-model="ticket.notificar"
                                label="Notificar"
                                :readonly="!edit"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="6" md="1">
                            <v-checkbox
                                dense
                                :readonly="!edit"
                                v-model="ticket.interno"
                                label="Interno"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                :readonly="!edit"
                                label="Nombre Externo"
                                v-model="ticket.nombre_ext"
                                dense
                                outlined
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                label="Email Externo"
                                v-model="ticket.email_ext"
                                dense
                                outlined
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="3">
                            <v-autocomplete
                                label="Cliente"
                                :readonly="!edit"
                                outlined
                                dense
                                v-model="ticket.id_usuario"
                                :items="clientes"
                                item-text="nombres"
                                item-value="id"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-autocomplete
                                label="Proyecto"
                                outlined
                                :readonly="!edit"
                                dense
                                v-model="ticket.id_proyecto"
                                :items="proyectos"
                                item-text="nombre"
                                item-value="id"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field
                                dense
                                outlined
                                type="number"
                                v-model="ticket.tiempo_estimado"
                                label="Minutos"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-autocomplete
                                label="Responsable"
                                outlined
                                :readonly="!edit"
                                dense
                                v-model="ticket.id_responsable"
                                :items="responsables"
                                item-text="nombre"
                                item-value="id"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                label="Titulo"
                                outlined
                                dense
                                v-model="ticket.titulo"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <RichTextComponent
                                v-model="ticket.descripcion"
                                uploadUrl="api/ticket/image"
                                :fixedToolbar="false"
                                :readonly="!canEditDescripcion"
                            ></RichTextComponent>
                            <h4
                                style="
                                    padding-top: 1rem;
                                    padding-bottom: 1rem;
                                "
                            >
                                Descripción Interna
                            </h4>
                            <RichTextComponent
                                v-model="ticket.descripcion_interna"
                                uploadUrl="api/ticket/image"
                                :fixedToolbar="false"
                                :readonly="!canEditDescripcion"
                            ></RichTextComponent>
                        </v-col>
                    </v-row>
                    <ArchivosComponentVue
                        v-model="ticket.archivos"
                    ></ArchivosComponentVue>
                </v-form>
                
                <!-- Sección de comentarios -->
                <ComentariosTicketVue
                    v-if="ticketId && ticket.id"
                    :ticket-id="ticket.id"
                    @comentarios-leidos="$emit('comentarios-leidos', ticket.id)"
                ></ComentariosTicketVue>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="pa-4">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            @click="closeDialog"
                            color="blue"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text"
                                >mdi-arrow-left-bold-outline</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>Volver</span>
                </v-tooltip>

                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            @click="saveTicket"
                            :loading="loading"
                            :disabled="loading"
                            color="success"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text"
                                >mdi-content-save-all</v-icon
                            >
                        </v-btn>
                    </template>
                    <span v-if="ticketId">Actualizar</span>
                    <span v-else>Guardar</span>
                </v-tooltip>

                <v-tooltip v-if="ticketId && edit" top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            @click="confirmDelete"
                            :loading="loading"
                            :disabled="loading"
                            color="red"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text">mdi-trash-can</v-icon>
                        </v-btn>
                    </template>
                    <span>Eliminar</span>
                </v-tooltip>

                <v-tooltip v-if="ticketId" top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            @click="openTareaDialog"
                            :loading="loading"
                            :disabled="loading"
                            color="orange darken-1"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text">mdi-file-tree</v-icon>
                        </v-btn>
                    </template>
                    <span>Generar Tarea</span>
                </v-tooltip>

                <v-tooltip v-if="ticketId" top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            @click="gotoChat"
                            :loading="loading"
                            :disabled="loading"
                            color="#1F1C91"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text">mdi-chat</v-icon>
                        </v-btn>
                    </template>
                    <span>Chat</span>
                </v-tooltip>

                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>

        <!-- Diálogo de confirmación de eliminación -->
        <v-dialog v-model="deleteDialog" max-width="500px">
            <v-card>
                <v-card-title class="text-h5 text-center">
                    ¿Confirmar eliminación?
                </v-card-title>
                <v-card-text class="text-center">
                    ¿Estás seguro de que deseas eliminar este ticket? Esta
                    acción no se puede deshacer.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" text @click="deleteDialog = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="red" text @click="deleteTicket">
                        Eliminar
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog para generar tarea -->
        <TareaDialogVue
            v-model="tareas_dialog"
            :id_proyecto="ticket.id_proyecto"
            :fecha="new Date().toISOString().slice(0, 10)"
            :descripcion="ticket.titulo"
            :id_ticket="ticket.id"
        ></TareaDialogVue>
    </v-dialog>
</template>

<script>
import RichTextComponent from '../../modulos/tickets/componentes/RichTextComponent.vue';
import ArchivosComponentVue from '../../modulos/tickets/componentes/ArchivosComponent.vue';
import TareaDialogVue from '../../modulos/tickets/componentes/TareaDialog.vue';
import ComentariosTicketVue from './ComentariosTicket.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        RichTextComponent,
        ArchivosComponentVue,
        TareaDialogVue,
        ComentariosTicketVue,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        ticketId: {
            type: [Number, String],
            default: null,
        },
        initialProyectoId: {
            type: [Number, String],
            default: null,
        },
    },
    data() {
        return {
            dialog: false,
            valid: false,
            loading: false,
            deleteDialog: false,
            tareas_dialog: false,
            proyectos: [],
            estados: [],
            departamentos: [],
            responsables: [],
            clientes: [],
            urgencia: [],
            ticket: {
                id: null,
                id_usuario: null,
                id_urgencia: null,
                id_departamento: null,
                id_estado_ticket: null,
                fecha_realizacion: null,
                fecha_finalizacion: null,
                notificar: false,
                tiempo_estimado: 0,
                interno: false,
                archivos: [],
                titulo: '',
                descripcion: '',
                descripcion_interna: '',
                nombre_ext: '',
                email_ext: '',
                id_proyecto: null,
                id_responsable: null,
            },
        };
    },
    watch: {
        value(val) {
            this.dialog = val;
            if (val) {
                this.loadData();
            }
        },
        dialog(val) {
            this.$emit('input', val);
            if (!val) {
                this.$emit('close');
            }
        },
        ticketId(val) {
            if (val && this.dialog) {
                this.getTicket(val);
            }
        },
        'ticket.id_usuario'(val) {
            if (val) {
                this.getProyectosByUser(val);
            }
        },
    },
    methods: {
        async loadData() {
            this.loading = true;
            try {
                await Promise.all([
                    this.getEstados(),
                    this.getDepartamentos(),
                    this.getResponsables(),
                    this.getAllClientes(),
                    this.getUrgencia(),
                ]);

                if (this.ticketId) {
                    await this.getTicket(this.ticketId);
                } else {
                    this.resetTicket();
                    this.applyNewTicketDefaults();
                    if (this.initialProyectoId && this.ticket.id_usuario) {
                        this.getProyectosByUser(this.ticket.id_usuario);
                    }
                }
            } finally {
                this.loading = false;
            }
        },

        findCatalogItemByTerms(list, terms) {
            if (!Array.isArray(list) || list.length === 0) {
                return null;
            }
            return list.find((item) => {
                const desc = (item.descripcion || "").toLowerCase();
                return terms.some((term) => desc.includes(term));
            });
        },

        addBusinessDays(date, businessDays) {
            const cursor = new Date(date);
            let added = 0;
            while (added < businessDays) {
                cursor.setDate(cursor.getDate() + 1);
                const day = cursor.getDay();
                if (day !== 0 && day !== 6) {
                    added++;
                }
            }
            return cursor.toISOString().slice(0, 10);
        },

        applyNewTicketDefaults() {
            const estado = this.findCatalogItemByTerms(this.estados, [
                "pendiente",
            ]);
            const departamento = this.findCatalogItemByTerms(this.departamentos, [
                "tecnico",
                "técnico",
            ]);
            const urgencia = this.findCatalogItemByTerms(this.urgencia, ["baja"]);
            const fechaObjetivo = this.addBusinessDays(new Date(), 3);

            if (estado) {
                this.ticket.id_estado_ticket = estado.id;
            }
            if (departamento) {
                this.ticket.id_departamento = departamento.id;
            }
            if (urgencia) {
                this.ticket.id_urgencia = urgencia.id;
            }
            this.ticket.fecha_realizacion = fechaObjetivo;
            this.ticket.fecha_finalizacion = fechaObjetivo;
        },

        resetTicket() {
            this.ticket = {
                id: null,
                id_usuario: null,
                id_urgencia: null,
                id_departamento: null,
                id_estado_ticket: null,
                fecha_realizacion: null,
                fecha_finalizacion: null,
                notificar: false,
                tiempo_estimado: 0,
                interno: false,
                archivos: [],
                titulo: '',
                descripcion: '',
                descripcion_interna: '',
                nombre_ext: '',
                email_ext: '',
                id_proyecto: this.initialProyectoId || null,
                id_responsable: null,
            };
            // Si hay un proyecto inicial, cargar los proyectos del cliente si existe
            if (this.initialProyectoId && this.ticket.id_usuario) {
                this.getProyectosByUser(this.ticket.id_usuario);
            }
        },

        getTicket(id) {
            return axios
                .get(`api/get-ticket/${id}`)
                .then((response) => {
                    this.ticket = response.data.success;
                })
                .catch((err) => {
                    this.$toast.error('Error consultando ticket');
                });
        },

        getProyectosByUser(userId) {
            axios
                .get(`api/get-proyectos-by-user-id/${userId}/0`)
                .then((res) => {
                    this.proyectos = res.data;
                })
                .catch((err) => {
                    this.$toast.error('Error consultando proyectos');
                });
        },

        getEstados() {
            return axios.get('api/get-estado-tickets').then((res) => {
                this.estados = res.data.success;
            });
        },

        getDepartamentos() {
            return axios.get('api/get-departamentos').then((res) => {
                this.departamentos = res.data.success;
            });
        },

        getUrgencia() {
            return axios.get('api/get-urgencia').then((res) => {
                this.urgencia = res.data.success;
            });
        },

        getResponsables() {
            return axios
                .post(`api/get-usuarios-empleados-all`)
                .then((res) => {
                    this.responsables = res.data.users;
                })
                .catch((err) => {
                    this.$toast.error('Error consultando responsables');
                });
        },

        getAllClientes() {
            return axios
                .get(`api/get-all-clientes`)
                .then((res) => {
                    this.clientes = res.data.users;
                })
                .catch((err) => {
                    this.$toast.error('Error consultando clientes');
                });
        },

        saveTicket() {
            this.loading = true;
            const ruta = this.ticketId ? 'update-ticket' : 'create-ticket';

            axios
                .post(`api/${ruta}`, this.ticket)
                .then((response) => {
                    this.$toast.sucs(
                        this.ticketId
                            ? 'Ticket actualizado con éxito'
                            : 'Ticket creado con éxito'
                    );
                    if (!this.ticketId && response.data.data) {
                        this.ticket.id = response.data.data.id;
                    }
                    this.$emit('ticket-saved', response.data.data);
                    this.closeDialog();
                })
                .catch((err) => {
                    this.$toast.error('Error guardando ticket');
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        confirmDelete() {
            this.deleteDialog = true;
        },

        deleteTicket() {
            this.loading = true;
            axios
                .get(`api/delete-ticket/${this.ticket.id}`)
                .then((response) => {
                    this.$toast.sucs('Ticket eliminado');
                    this.deleteDialog = false;
                    this.$emit('ticket-saved');
                    this.closeDialog();
                })
                .catch((err) => {
                    this.$toast.error('Error eliminando ticket');
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        openTareaDialog() {
            this.tareas_dialog = true;
        },

        gotoChat() {
            axios.get(`api/get-chat/${this.ticket.id}`).then((res) => {
                this.$router.push(`/lista-chats?id=${this.ticket.id}`);
            });
        },

        closeDialog() {
            this.dialog = false;
        },

        getCreadorNombre(creador) {
            // Si existe creador_nombre (viene del backend formateado), usarlo
            if (this.ticket.creador_nombre) {
                return this.ticket.creador_nombre;
            }
            // Si no, intentar obtenerlo del objeto creador
            if (!creador) return 'Sin información';
            if (typeof creador === 'string') return creador;
            if (creador && creador.nombre) return creador.nombre;
            return 'Sin información';
        },

    },
    computed: {
        ...mapGetters({
            userRole: 'auth/userRole',
            userData: 'auth/userData',
        }),
        edit() {
            const role = this.userRole;
            const permisos = this.userData?.permissions || [];

            return (
                role == 1 ||
                role == 5 ||
                role == 9 ||
                role == 7 ||
                role == 6 ||
                role == 12 ||
                permisos.includes('Tickets')
            );
        },
        isDateSelectDisabled() {
            const rol = this.userRole;
            if (this.ticket.id != null && rol != 1 && rol != 5 && rol != 12) {
                return true;
            }
            return false;
        },
        canEditDescripcion() {
            if (!this.ticket.id) return true; // Si es nuevo ticket, se puede editar
            if (!this.ticket.id_creador) return this.edit; // Si no hay creador, usar permisos normales
            return this.userData && this.ticket.id_creador === this.userData.id;
        },
    },
};
</script>

<style scoped>
/* Estilos adicionales si son necesarios */
</style>

